import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feat-map-filter',
  templateUrl: './feat-map-filter.component.html',
  styleUrls: ['./feat-map-filter.component.css']
})
export class FeatMapFilterComponent implements OnInit, OnDestroy {

	isMapFilterOn: boolean;

	isActionDisabled: boolean;

	private mapFilterSub: Subscription;
	private mapFilterDisableSub: Subscription;
	private mapMoveProcessingSub: Subscription;
	private reportTypeSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private reportService: InterlayerReportService
	) { }

	onToggleMapFilter() {
		if (this.isActionDisabled) {
			return;
		}
		this.isMapFilterOn = !this.isMapFilterOn;
		this.activityService.mapFilterBS.next({
			isOn: this.isMapFilterOn
		});
	}

	private updateMapFilterDisable() {
		let disabled = false;
		const reportType = this.reportService.reportTypeBS.getValue();
		if (reportType && reportType.type === 'FISHBONE') {
			disabled = true;
		}
		else if (this.activityService.mapMoveProcessingBS.getValue() && this.activityService.mapMoveProcessingBS.getValue().isProcessing) {
			disabled = true;
		}
		if (disabled !== this.isActionDisabled) {
			this.activityService.mapFilterDisableBS.next({
				disabled: disabled
			});
		}
	}
	ngOnInit() {
		this.mapFilterSub = this.activityService.mapFilterBS.subscribe(data => {
			if (data.isOn !== this.isMapFilterOn) {
				this.isMapFilterOn = data.isOn;
			}
			// if (data.hasOwnProperty('disabled')) {
			// 	this.isActionDisabled = data.disabled;
			// }
		});
		this.mapFilterDisableSub = this.activityService.mapFilterDisableBS.subscribe(data => {
			this.isActionDisabled = data.disabled;
		});
		this.mapMoveProcessingSub = this.activityService.mapMoveProcessingBS.subscribe(data => {
			this.updateMapFilterDisable();
		})
		this.reportTypeSub = this.reportService.reportTypeBS.subscribe(() => {
			this.updateMapFilterDisable();
		});
	}
	ngOnDestroy(): void {
		this.mapFilterSub.unsubscribe();
		this.mapFilterDisableSub.unsubscribe();
		this.mapMoveProcessingSub.unsubscribe();
		this.reportTypeSub.unsubscribe();
	}
}
